function fn_comp_hp_references(){
    var $fn = $(".comp_hp_references");

    if($fn.length){
        $fn.find(".elm_reference_content").each(function (index) {
            var $this = $(this);
            var $points = [];
            if(index%2==0){
                $points=[[97.4,100], [100,0], [0,0], [0,97.2]];
            }
            else {
                $points = [[98.1,100], [100,1.9], [1.9,0.8], [0,97] ];
            }

            $this.clipPath($points, {
                isPercentage: true,
                svgDefId: "referenceclip"+index
            })
        })
    }
}